import { ShieldCheck } from "lucide-react";

/**
 * Slim educational banner — sits at the very top of every page.
 * Educational-only positioning + accessible to screen readers.
 */
const EducationalBanner = () => (
  <div className="bg-[#0B5F58] text-white text-xs" role="note" aria-label="Educational disclaimer">
    <div className="mp-container py-2 flex items-center justify-center gap-2 text-center">
      <ShieldCheck className="w-3.5 h-3.5 shrink-0 text-[#A7F3D0]" />
      <span className="leading-tight">
        Educational information only — MortgagePath is not a broker, lender or regulated mortgage adviser.
      </span>
    </div>
  </div>
);

export default EducationalBanner;
